import ServiceLocator from "../../../global/service-locator";
import { initCoachInfo } from "../../../components/coach-info";
import LoadMoreObserver from "../../../components/load-more-observer";
import ModalForm from "../../../components/base/forms/modal-form";
import CoachesSearch from "./coaches-search";

export default class PageModule {
	constructor() {
		this.modalService = ServiceLocator.instance.modalService;

		this.initCoachInfoModal();
		this.initCoachesSearch();
		this.initLazyLoadObserver();
		this.initBecomeCoachForm();
	}

	initCoachInfoModal() {
		const $coachCardList = document.querySelectorAll('.coach-card');

		try {
			this.modalService.register('coach-info', Array.from($coachCardList), {
				beforeOpen: ($trigger) => {
					initCoachInfo($trigger.closest('.coach-card'));
				}
			});
		} catch (err) {
			console.error('Coach Info Modal:', err);
		}
	}

	initCoachesSearch() {
		const $coachesSearchBlock = document.getElementById('blockCoachesSearch');

		if ($coachesSearchBlock) {
			this.coachesSearch = new CoachesSearch({
				$root: $coachesSearchBlock,
				afterFetch: ($coaches) => {
					this.modalService.getItem('coach-info').setTrigger(Array.from($coaches));
				}
			});
		}
	}

	initLazyLoadObserver() {
		this.lazyLoadObserver = new LoadMoreObserver({
			$root: document.getElementById('blockCoaches'),
			afterObserve: () => {
				const $coachCardList = document.querySelectorAll('.coach-card');
				this.modalService.getItem('coach-info').setTrigger(Array.from($coachCardList));
			}
		});
	}

	initBecomeCoachForm() {
		const id = 'become-coach';
		const $trigger = document.querySelector(`[data-modal="${id}"]`);

		if ($trigger) {
			try	{
				this.consultationForm = new ModalForm({
					formId: id,
					uri: '/2.0/coaches/registration',
					$modalTriggers: [$trigger]
				});
			} catch (err) {
				console.error('Become Coach Form:', err);
			}
		}
	}
}